<template>
    <div id="activity-board" class="cmp-activity-board">
        <h2>
            <span class="icon-heading"><icon class="icon" type="solid" name="faTachometerAlt" aria-hidden="true"></icon> Search Dashboard</span>
            <span class="toggle-icon"><icon type="solid" name="faChevronDown" aria-hidden="true"></icon></span>
        </h2>
        <div class="activityHeader">
            <a class="activityItem no-underline" href="#" title="Show a Map" @click.prevent="showMap">
                <icon class="icon" type="solid" name="faMap" aria-hidden="true"></icon>
                <span class="item-description">Show a <strong>Map</strong></span>
            </a>
            <a class="activityItem no-underline" href="#" title="Run a Different Search" @click.prevent="showSearch">
                <icon class="icon" type="solid" name="faSearch" aria-hidden="true"></icon>
                <span class="item-description">Run a Different <strong>Search</strong></span>
            </a>
            <a class="activityItem no-underline" href="#" title="View your Search History" @click.prevent="showSearchHistory">
                <icon class="icon" type="solid" name="faHistory" aria-hidden="true"></icon>
                <span v-if="searchCount > 0" class="badge">{{ searchCount > 99 ? '99+' : searchCount }}</span>
                <span class="item-description">View your <strong>Search History</strong></span>
            </a>
            <a class="activityItem no-underline" href="#" title="View your Call History" @click.prevent="showCallHistory">
                <icon class="icon" type="solid" name="faTools" aria-hidden="true"></icon>
                <span v-if="callCount > 0" class="badge">{{ callCount > 99 ? '99+' : callCount }}</span>
                <span class="item-description">View your <strong>Call History</strong></span>
            </a>
        </div>
        <div v-if="panel == 'map'" class="map">
            <activity-board-map :listings="listings" :request="request" :start-marker="markerToOpen"></activity-board-map>
        </div>
        <transition name="expand" appear mode="in-out">
            <div v-if="panel == 'search'" class="panel search-panel">
                <search-form :status="statusText" :services="services" :regions="regions"></search-form>
            </div>
        </transition>
        <transition name="expand" appear mode="in-out">
            <div v-if="panel == 'searchHistory'" class="panel search-history">
                <activity-board-search-history :services="services"></activity-board-search-history>
            </div>
        </transition>
        <transition name="expand" appear mode="in-out">
            <div v-if="panel == 'callHistory'" class="panel call-history">
                <activity-board-call-history></activity-board-call-history>
            </div>
        </transition>
    </div>
</template>

<script>import script from './ActivityBoard';
    export default script;</script>

<style lang="less">
    @import "./ActivityBoard.less";
</style>
